import React from "react";
import { withStyles, Typography, FormControl, InputLabel, Input } from "@material-ui/core";
import Clear from "@material-ui/icons/Clear"
import Check from "@material-ui/icons/Check"

import PropTypes from "prop-types";
import cx from "classnames";

import customInputStyle from "../../assets/jss/material-dashboard-react/customInputStyle";

function EditInput({ ...props }) {
  const {autoCapitalize,secureTextEntry,keyboardType,onChangeText,onBlur,label
    ,value,description,editLastName,editCountry,editFirstName,editEmail,onPress,autoFocus} = props; 

  const {
   // value,
    classes,
    formControlProps,
    labelText,
    id,
    labelProps,
    inputProps,
    error,
    success
  } = props;

  const labelClasses = cx({
    [" " + classes.labelRootError]: error,
    [" " + classes.labelRootSuccess]: success && !error
  });
  const underlineClasses = cx({
    [classes.underlineError]: error,
    [classes.underlineSuccess]: success && !error,
    [classes.underline]: true
  });
  const marginTop = cx({
    [classes.marginTop]: labelText === undefined
  });
  //var thisisit = "Carey";
  
  return (
    <FormControl
      {...formControlProps}
      className={formControlProps.className + " " + classes.formControl}
    >
      {labelText !== undefined ? (
        <Typography style={styles.label}>
      {labelText}
   </Typography>
        /* <InputLabel
          className={classes.labelRoot + labelClasses}
          htmlFor={id}
          {...labelProps}
        >
          {labelText}
        </InputLabel>*/
      ) : null} 
      <Input
        value={value}
        classes={{
          root: marginTop,
          disabled: classes.disabled,
          underline: underlineClasses,
        }}
        id={id}
        {...inputProps}
      />
      {props.error ? <Typography style={styles.errorColor}>{props.error}</Typography> : null}
      {error ? (
        <Clear className={classes.feedback + " " + classes.labelRootError} />
      ) : success ? (
        <Check className={classes.feedback + " " + classes.labelRootSuccess} />
      ) : null}
    </FormControl>
  );
}

EditInput.propTypes = {
  classes: PropTypes.object.isRequired,
  value: PropTypes.string,
  labelText: PropTypes.node,
  labelProps: PropTypes.object,
  id: PropTypes.string,
  inputProps: PropTypes.object,
  formControlProps: PropTypes.object,
  error: PropTypes.string,
  success: PropTypes.bool
};

const styles = {
  label: {
    //...defaultFont,
    color: "#AAAAAA",
    fontWeight: "400",
    fontSize: "14px",
    lineHeight: "1.42857",
    //marginTop: "16px"
  },
  errorColor: {
    color:"#f44336",
  },
};

export default withStyles(customInputStyle)(EditInput);



// WEBPACK FOOTER //
// ./src/components/CustomInput/EditInput.jsx